import { projectRequest } from 'store/utils/request';

export const getDictionaryColumnsRequest = async (dictionaryId, params) => {
  try {
    return await projectRequest.get(`/dictionaries/${dictionaryId}/columns/`, {
      params,
    });
  } catch (error) {
    throw error;
  }
};

export const addDictionaryColumnRequest = async (dictionaryId, data) => {
  try {
    return await projectRequest.post(
      `/dictionaries/${dictionaryId}/columns/`,
      data,
    );
  } catch (error) {
    throw error;
  }
};

export const getDictionaryColumnRequest = async (dictionaryId, id) => {
  try {
    return await projectRequest.get(
      `/dictionaries/${dictionaryId}/columns/${id}/`,
    );
  } catch (error) {
    throw error;
  }
};

export const updateDictionaryColumnRequest = async (dictionaryId, id, data) => {
  try {
    return await projectRequest.put(
      `/dictionaries/${dictionaryId}/columns/${id}/`,
      data,
    );
  } catch (error) {
    throw error;
  }
};

export const deleteDictionaryColumnRequest = async (dictionaryId, id) => {
  try {
    return await projectRequest.delete(
      `/dictionaries/${dictionaryId}/columns/${id}/`,
    );
  } catch (error) {
    throw error;
  }
};
